import {BackButton} from "@/components/layout";

export const SignUpHeader: React.FC = () => {
  return (
    <div className="py-4 flex justify-center items-center w-full sticky top-0 bg-background z-10">
      <h1 className="font-bold text-xl">Регистрация</h1>
      <div className="absolute left-0">
        <BackButton />
      </div>
    </div>
  );
};
